import { buildApiUrl, resolveApiBaseWithDefault } from './apiBase';
import { createApiHttpClient } from './httpClient';

export const CALENDAR_API_BASE = resolveApiBaseWithDefault(
  import.meta.env.VITE_CALENDAR_API_URL,
  '/api/calendar'
);

export const buildCalendarUrl = (path: string) => buildApiUrl(CALENDAR_API_BASE, path);

export const calendarHttp = createApiHttpClient();
